import { useEffect, useState } from 'react';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_LG } from '../../../../theme/Component/hooks/useModal';
import { toast } from 'react-toastify';
import { _UBLAdminFee } from '../../../../../core/services/dataBean/EntityCatalog';
import { Modal } from '../../../../theme/Component/Modal';
import { UBLAdminFee } from './UBLAdminFee';

interface Props {
    label?: string;
    idSelector: number;
    onChange: (value: any) => void;
    disabled?: boolean;
}

export const EditorUBLAdminFee = ({ idSelector, label, onChange, disabled }: Props) => {
    const { instance } = useDataBean(_UBLAdminFee);

    const modal = useModal("Catalogo de Tipos de AIU", MODAL_LG);

    const [valor, setValor] = useState('');
    const [obj, setObj] = useState<any>({});

    const getProperties = (item: any) => {
        return item?.DataBeanProperties ?? item ?? {};
    };

    const getDisplayValue = (item: any) => {
        const data = getProperties(item);

        if (!data?.IDUBLAdminFee && !data?.Name) {
            return '';
        }

        return `${data.IDUBLAdminFee ?? ''} - ${data.Name ?? ''}`;
    };

    useEffect(() => {
        if (idSelector) {
            getItem();
        } else {
            setValor('');
            setObj({});
        }
    }, [idSelector]);

    const getItem = () => {
        instance.getUBLAdminFee(idSelector).then((resp: any) => {
            setObj(resp);
            setValor(getDisplayValue(resp));
            onChange(resp);
        }).catch(() => {
            toast.error("Tipo de AIU no encontrado");
            setValor('');
            setObj({});
        });
    };

    const returnValue = () => {
        const data = getProperties(obj);

        if (data?.IDUBLAdminFee) {
            setValor(getDisplayValue(obj));
            modal.close();
            onChange(obj);
        } else {
            toast.error("Tipo de AIU no valido");
        }
    };

    return (
        <>
            {label && label !== " " && (
                <label>{label ?? "Seleccione un Tipo de AIU"}</label>
            )}

            <div
                className={`form-control text-wrap ${disabled ? 'bg-light text-muted' : 'cursor-pointer'}`}
                style={{ minHeight: '35px' }}
                onClick={() => {
                    if (!disabled) {
                        modal.open();
                    }
                }}
            >
                {valor ? valor : <span>Seleccionar...</span>}
            </div>

            <Modal
                onSubmitLabel="Seleccionar"
                modal={modal.modal}
                updateModal={modal.setModal}
                eventModal={returnValue}
            >
                <UBLAdminFee
                    isModal
                    _onChange={(e: any) => {
                        setObj(e);
                    }}
                />
            </Modal>
        </>
    );
};
